/// <reference types="../commons.d.ts" preserve="true" />
/**
 * The EventQ(ueue)Bus is a JavaScript library that enables communication between asynchronous components in the frontend, regardless of loading time.
 *
 * {@include ../lib/event-q-bus/README.md}
 * @category Legacy Modules
 * @module event-q-bus
 * @deprecated
 * @packageDocumentation
 */
import { o_global } from "@gr-common/common/namespaces";
import type { QBusEventMap } from "../lib/event-q-bus/q-bus/index.js";
import type { EventLoaderEvents } from "./event-loader.js";
import type { QBus } from "@gr-exports/head/event-q-bus";

export type {
  QBus,
  QBusEventEnum,
  QBusEventMap,
  QBusOptions,
  TopicName,
} from "../lib/event-q-bus/q-bus/index.js";

export type { QBusTopic, EventData, EventCallback } from "../lib/event-q-bus/utils/index.js";

/**
 * Can be used to make calls to {@link OttoGlobal.eventQBus} in a typed way.
 *
 * You will find more docs by navigating into member types
 *
 * - {@link EventLoaderEvents}
 * - {@link PreloadEvents}
 *
 * @example
 *
 * ```ts
 * window.o_global.eventQBus.with<GlobalEvents>()
 *  .on("assets.events.windowLoad", (payload) => {
 *    // get intellisence here
 *  })
 *
 *
 * // this way works too
 *
 * const bus = window.o_global.eventQBus as QBus<GlobalEvents>;
 * ```
 *
 * @deprecated use nexus instead https://github.com/otto-ec/assets_global-resources/blob/main/src/lib/nexus/README.md
 */
export type GlobalEvents = QBusEventMap<EventLoaderEvents>;

/**
 * Can be used to create an instance of {@link OttoGlobal.eventQBus} in a typed way.
 * @deprecated use nexus instead
 */
export const events: OttoGlobal["events"] = o_global.events;

/**
 * Instance of the EventQ(ueue)Bus module.
 * @deprecated use nexus instead
 */
export const eventQBus: QBus = o_global.eventQBus;
